import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImages } from '@fortawesome/free-regular-svg-icons'
import Resizer from 'react-image-file-resizer'
import { postSupportsApi } from '../../Api/BarestSupplierServices'
import Button from '../../Components/Button/Button'
import Input from '../../Components/Input/Input'
import MenuTitle from '../../Components/MenuTitlle/MenuTitle'
import { errorToast, succToast } from '../../Utils/Toast/Toast'
import Style from './Support.module.css'
const Support = () => {
    const[title , setTitle]=useState('')
    const[message , setMessage]=useState('')
    const[images, setImages]=useState()

    const sendMessageHandler=(e)=>{
        e.preventDefault()
        let info={
            title:title,
            message:message,
            file:images
        }
        postSupportsApi(info , (suc=>{
            if(suc.status==='0'){
                errorToast("error");
            }
            else{
                succToast("باموفقیت ارسال شد")
            }
        }))
    }
    const UploadImage=async(e)=>{
        try{
            const file=e.target.files[0]
            const image=await resizeFile(file)
            setImages(image)
            console.log(image)
        }catch(err){
            console.log(err)
        }
    }
    const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                1024,
                1024,
                "WEBP",
                100,
                0,
                (uri) => {
                    resolve(uri)
                },
                "base64"
            )
        })
    return (
        <div className={Style.PageHolder}>
            <MenuTitle title="پشتیبانی"/>
            <div className={Style.center}>
                <div className={Style.imageHolder}><img src="/Assets/Images/support/support.png" alt="support" /></div>
                <form action="" className={Style.formHolder}>
                    <Input placeholder="عنوان درخواست" value={title} onChange={(e)=>setTitle(e.target.value)}/>
                    <Input inputtype='textArea' value={message} onChange={(e)=>setMessage(e.target.value)} placeholder="متن درخواست شما..."/>
                    <div className={Style.FileDivison}>
                        <p>بارگذاری فایل</p>
                        <label htmlFor="file"><FontAwesomeIcon icon={faImages}/></label>
                        <input type="file" id="file" onChange={(e)=>UploadImage(e)}/>
                    </div>
                    <Button Value={'ارسال'} ClickHandler={sendMessageHandler} ClassBtn={'confirmBtn'}/>
                </form>
            </div>
        </div>
    )
}

export default Support
